// PDF表示用
import React, { useState } from 'react';
import { Document, Page } from 'react-pdf';
import LoadingModal from './LoadingModal';
import { isSmartPhone } from '../BrowserJudgment';

interface Props {
  url: string;
}

const ShowDocument: React.FC<Props> = ({ url }) => {
  const [numPages, setNumPages] = useState(1);
  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    setNumPages(numPages);
  };

  return (
    <>
      <div>
        <Document
          file={url}
          onLoadSuccess={onDocumentLoadSuccess}
          loading={<LoadingModal show={true} />}
          error=""
          noData=""
          options={{
            cMapUrl: '/cmaps/',
            cMapPacked: true,
          }}
        >
          <div className="pdf_viewer">
            {Array.from(new Array(numPages), (el, index) => (
              <Page
                key={index}
                pageNumber={index + 1}
                className="pdf_viewer_page"
                width={isSmartPhone() ? 350 : 800}
              />
            ))}
          </div>
        </Document>
      </div>
    </>
  );
};

export default ShowDocument;
